import useSafeState from '../utils/safe-state';
import React, {useEffect, useState, useRef} from "react";
import {Form, Row, Col, Input, Button, message, Select, List, Card, Spin, Modal, Checkbox, CheckboxProps} from 'antd';
import {Trans} from "@lingui/macro";
import {useAxios} from "../utils/hooks";
import { AxiosResponse, AxiosError } from 'axios';

import {antdContext} from "../utils/antdContext";
import { openNotification } from '../utils/openNotification';
import {SelectType} from "../interfaces/SelectType";
import {MinusOutlined} from "@ant-design/icons";


interface Interface{
    locationId?: any;
    mode?: "View" | "AddNew" | "Edit";
}

const NewLocationForm = (props : Interface) => {

    const [form] = Form.useForm();
    
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");

    const [loading, setLoading] = useSafeState(false);

    const [canContinue, setCanContinue] = useSafeState<boolean>();
    const [isView, setIsView] = useSafeState<any>(false);
    const [isEdit, setIsEdit] = useSafeState<boolean>();
    const [isNewUser, setIsNewUser] = useSafeState<boolean>(true);

    const [loginName, setLoginName] = useSafeState<string>();
    const [userRoles, setUserRoles] = useSafeState<Array<string>>([]);
    const [allRoles, setAllRoles] = useSafeState<any>();
    const [deleteItem, setDeleteItem] = useSafeState<any>();
    const [isModalVisible, setIsModalVisible] = useSafeState(false);


    const viewMode = () => {
        if(axiosInstance.current != null) {
            
            axiosInstance.current.get("/resource/users/get-user-data?userName=" + loginName, {})
                .then(function (response : AxiosResponse<any>)
                {
                    let user = JSON.parse(JSON.stringify(response.data));
                    form.setFieldsValue({"loginname": user.loginName});
                    form.setFieldsValue({"email": user.email});
                    form.setFieldsValue({"username": user.username});

                }).catch(function (error :any) {
                    message.error(antdContext('Hiba a lekérdezés közben')).then(r => {console.log(r)});
                    console.log(error)
                    setLoading(false);
            });

            
        }
    }

    const getAllRoles = () => {

        if(axiosInstance.current != null) {
            
            axiosInstance.current.get("/resource/roles/get-all-roles", {})
                .then(function (response : AxiosResponse<any>) {

                    let tmpArr: Array<SelectType> = [];
                    response.data.forEach((key:any) => {
                        tmpArr.push(
                            {
                                label: key,
                                value: key
                            })
                        })
                    setAllRoles(tmpArr);
                    console.log(tmpArr);

                }).catch(function (error :any) {
                    message.error(antdContext('Hiba a lekérdezés közben')).then(r => {console.log(r)});
                    console.log(error)
                    setLoading(false);
            });

            
        }

    }

    const getUserRoles = () => {

        if(axiosInstance.current != null) {
            
            axiosInstance.current.get("/resource/userrole/get-users-roles?userName=" + loginName, {})
                .then(function (response : AxiosResponse<any>) {
                    setUserRoles(response.data);
                })
                .catch(function (error :any) {
                    message.error(antdContext('Hiba a lekérdezés közben')).then(r => {console.log(r)});
                    console.log(error)
                    setLoading(false);
            });
        }

    }

    useEffect(() => {
        getAllRoles();
        let params:any = JSON.parse(JSON.stringify(props));
        
        setLoginName(params.data.loginName);
        let initMode:any = params.data == undefined ? undefined : params.data.mode;


        setIsView(initMode == 'View' ? true : false);
        setIsEdit(initMode == 'Edit' ? true : false);
        
    }, []);


    useEffect(() => {
        
        if (isView || isEdit) {
            setIsNewUser(false);
            getUserRoles();
            viewMode();
        }
    },[isView,isEdit]

    );

    const handleFinish = () => {
        

        if(axiosInstance.current != null) {
            setLoading(true);

            axiosInstance.current.put("/resource/user/add-update-user",
                {
                    username: form.getFieldValue(["username"]),
                    loginName: form.getFieldValue(["loginname"]),
                    email: form.getFieldValue(["email"]),
                    password: form.getFieldValue(["loginname"]), // Use loginname as password
                    roles: userRoles
                }
                ).then(function (response : AxiosResponse<any>)
                {      
                    setLoading(false);
                    openNotification('success','');
                    onReset();
                }).catch(function (error :AxiosError) {
                    console.log(error.response);
                    let errResp = JSON.parse(JSON.stringify(error.response));
                    let errMessage = errResp.data.message;
                    openNotification('error',errMessage);
                setLoading(false);
            });

        }
    }

    const onReset = () => {
        form.resetFields();
    };
    const handleOk = () => {
        setIsModalVisible(false);
        const newUserRoles = userRoles.filter(listItem => listItem !== deleteItem);
        setUserRoles(newUserRoles);
    }

    const handleCancel = () => {
        setIsModalVisible(false);  
    }

    const handleUserRolesListClick = (item:any) => {
        setDeleteItem(item);
        setIsModalVisible(true);
    }

    const handleAllRolesListClick = (item:any) => {
        if (userRoles.indexOf(item) == -1) {
            const newUserRoles = [...userRoles, item];
            setUserRoles(newUserRoles);
        }
    }

    const onChangeCanContinue: CheckboxProps['onChange'] = (e) => {
        setCanContinue(e.target.checked);
    };


    return(
        
                <Form id="newuser"  layout='vertical' form={form}  onFinish={() => handleFinish()}>
                <Spin spinning={loading}></Spin>
                <div style={{ marginBottom: 16, padding: '12px', backgroundColor: '#e6f7ff', border: '1px solid #91d5ff', borderRadius: '4px' }}>
                    <Trans>* The one-time password is always the same as the username. This must be changed on first login.</Trans>
                </div>
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item
                            name="loginname"
                            label={<Trans>Login Name</Trans>}
                            children={<Input disabled={props.mode == 'Edit'}/>}
                            rules={[{
                                type:"string",
                                required: true,
                                message: <Trans>Please enter the login name</Trans>
                            }]}
                        />
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            name="email"
                            label={<Trans>Email</Trans>}
                            children={<Input />}
                        />
                    </Col>
                    </Row>
                <Row>
                    <Modal title={<Trans>Are you sure want to delete this role</Trans>} visible={isModalVisible} onOk={handleOk}
                        onCancel={handleCancel} width={230}>
                            <span> {deleteItem} </span>

                    </Modal>
                </Row>
                <Form.Item
                    children={
                        <>
                            <Button htmlType="button" type="primary" onClick={() => form.submit()}>
                                <Trans>Save</Trans>
                            </Button>
                        </>
                    }
                />
            </Form>
    );

}
export default NewLocationForm;
